import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePageTitle } from '../providers/page-title.provider';

const pageTitles: Record<string, string> = {
  //my-tol
  '/olink/my-tol': 'My TOL',

  //profile
  '/olink/switch': 'Select Profile',
  '/settings/details': 'Details',
  '/olink/edit': 'Edit Profile',
  '/settings/delegate': 'Delegate Rights',
  '/olink/delete-olink': 'Delete OLink',
  
  //link-management
  '/olink/my': 'Link Management',
  '/olink/add': 'Add Links',

  //pesonalization
  '/olink/personalization': 'Personalization',
  '/olink/create-qr': 'Customize QR Code',

  //QR code management
  '/olink/source': 'QR Code Management',

  //smart redirects
  '/event/events': 'Smart Redirects',
  '/event/events-add': 'Add Smart Redirects',
  '/event/edit-event': 'Edit Smart Redirects',

  //statistics
  '/olink/statistic': 'Statistic',

  //settings
  '/settings/main': 'Settings',
  '/settings/account-edit': 'Account Edit',
  '/olink/premium': 'Plans',
  '/settings/terms-conditions': 'Terms & Conditions',
  '/settings/privacy-policy': 'Privacy Policy',
  '/settings/support': 'Contact Support',
  '/settings/delete': 'Delete Account',
  '/settings/newsletter': 'Newsletter',  

  //other  
  '/olink/create': 'Create TOL',  
  '/settings/notifications': 'Notifications',
  '/settings/invite': 'Invite to The Only Link',
};

export const usePageTitleUpdate = () => {
  const location = useLocation();
  const { setPageTitle } = usePageTitle();

  useEffect(() => {
    const path = location.pathname;
    const pathSegments = path.split('/');
    
    // First try to find a match for the base path (without the ID)
    const basePath = pathSegments.slice(0, -1).join('/');
    let title = pageTitles[basePath];
    
    // If no match found with base path, try the full path
    if (!title) {
      title = pageTitles[path];
    }
    
    // If still no match, try with fewer segments
    if (!title) {
      const shorterPath = pathSegments.slice(0, 3).join('/');
      title = pageTitles[shorterPath];
    }
    
    // If still no match, use default title
    setPageTitle(title || 'Site Title');
  }, [location.pathname, setPageTitle]);
};
